import styled from 'styled-components'
import Icon from 'antd/lib/icon'
import Button from 'antd/lib/button'
import { WHITE, RED, BLACK, BLUE_LIGHT, GRAY } from '../../../theme/colors'

interface StyleProps {
  isMinimized?: boolean
  index?: number
  secondary?: boolean
}

export const CompareIslandContainer = styled.div`
  padding: 0px 60px;
  padding-top: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  z-index: 1000;
  font-family: Avenir;
  height: ${({ isMinimized }: StyleProps) => isMinimized ? '94px' : '260px'};
  background-color: rgb(0 0 0 / 80%);
  display: flex;
  justify-content: center;
	align-items: center;
  transition: all .25s;
  @media (max-width: 767px) {
    padding: 0px 10px;
    flex-direction: column;
  }
  animation: fade-in-bottomCompare 0.3s cubic-bezier(0.390, 0.575, 0.565, 1.000) both;
  @keyframes fade-in-bottomCompare {
    0% {
      transform: translateY(10px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
  }
`

export const MinimizeButton = styled(Button)`
  position: absolute;
  background-color: ${WHITE};
  color: ${GRAY};
  top: -15px;
  padding-top: 2px;
  width: 27px;
  height: 27px;
  box-shadow: 0px 0px 5px #00000063;
  border-color: unset;
  z-index: 2;
`

export const CompareProductsTitle = styled.div`
  color: ${WHITE};
`

export const ProductList = styled.div`
  width: 80%;
	display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  @media (max-width: 767px) {
    width: 100%;
    height: 70%;
    align-items: center;
  }
`

export const CompareActions = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  width: 15%;
  height: 213px;
  @media (max-width: 767px) {
    width: 100%;
    flex-direction: row;
    height: 30%;
  }
`

export const StyledButton = styled(Button)`
  height: 40px;
  width: 100%;
  border-radius: 2px;
  background-color: #3faad3;
  color: ${WHITE};
  border-color: #3faad3;
  &:hover {
		background-color: ${WHITE};
    color: #3faad3;
    border-color: #3faad3;
  }
  &:disabled {
    background-color: lightgray;
  }
  @media (max-width: 767px) {
    margin: 0px 10px;
  }
`

export const StyledClearAllButton = styled(Button)`
  height: 40px;
  width: 100%;
  border-radius: 2px;
  background-color: unset;
  color: ${WHITE};
  border-color: ${BLUE_LIGHT};
  &:hover {
    background-color: unset;
    color: ${BLUE_LIGHT};
    border-color: ${BLUE_LIGHT};
  }
  @media (max-width: 767px) {
    margin: 0px 10px;
  }
`

export const ProductItem = styled.div`
  width: 150px;
  cursor: pointer;
	position: relative;
  @media (max-width: 767px) {
    width: 70px;
    padding: 0px 2px;
    height: 130px;
  }
  animation: fade-in-column-compare 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyleProps) => index ? index * 0.1 : 0 }s both;
  @keyframes fade-in-column-compare {
    0% {
      transform: translateX(-10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
`

export const ProductImage = styled.img`
  width: 100%;
  border-radius: 3px;
  ${({ secondary }: StyleProps) => secondary ? `
    background: radial-gradient(at 50% 70%, #c0c0c0, #8e8d91, #6a6a6e);
    height: 100%;
    max-height: 150px;
    max-width: 150px;
    object-fit: cover;
    @media (max-width: 698px) {
      max-height: 150px;
      max-width: 150px;
      height: 50%;
    }
  ` : ''}
`

export const ProductName = styled.div`
    color: #ffffff;
    font-size: 14px;
    font-weight: bold;
    line-height: 19px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    padding-top: 10px;
    @media (max-width: 767px) {
      font-size: 10px;
    }
`

export const DesignName = styled.div`
  font-size: 13px;
  color: #e3c68f;
  @media (max-width: 698px) {
    font-size: 10px;
    line-height: 1;
  }
`

export const DesignNameMin = styled.div`
  font-size: 10px;
  color: #e3c68f;
  line-height: 1;
  @media (max-width: 698px) {
    font-size: 9px;
    text-align: center;
  }
`

export const ProductDescription = styled.div`
    user-select: none;
    color: #d4d4d4;
    font-size: 12px;
    line-height: 16px;
    padding: 2px 0px;
    word-break: break-word;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 767px) {
      font-size: 10px;
    }
`

export const ProductPrice = styled.div`
    user-select: none;
    color: #d4d4d4;
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
`

export const ProductItemSkeleton = styled.div`
  width: 150px;
  height: 213px;
  border: 1px dashed #d4d4d4;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #d4d4d4;
  @media (max-width: 767px) {
    width: 70px;
    height: 70%;
    margin: 0px 2px;
  }
  animation: fade-in-column-compare 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyleProps) => index ? index * 0.1 : 0 }s both;
  @keyframes fade-in-column-compare {
    0% {
      transform: translateX(-10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
`

export const DeleteButton = styled(Icon)`
  font-size: 10px;
  top: 5px;
  right: 5px;
  display: block;
  position: absolute;
  z-index: 9;
  padding: 4px;
  border-radius: 50%;
  border: 1px solid ${BLACK};
  color: ${BLACK};
  transition: all .25s;
  &:hover {
    color: ${WHITE};
    background: ${RED};
		border: 1px solid ${RED};
  }
  @media (min-width: 320px) and (max-width: 767px) {
    filter: drop-shadow(0px 0px 2px black);
    color: ${WHITE};
  }
`

export const ProductListMin = styled.div`
  display: flex;
  justify-content: center;
  width: fit-content;
  position: relative;
`

export const ProductItemMin = styled.div`
  max-width: 140px;
  cursor: pointer;
  position: relative;
  margin-right: 32px;
  ${({ secondary }: StyleProps) => secondary ? `
    display: flex;
    flex-flow: column;
    align-items: center;
  ` : ''}
  @media (max-width: 698px) {
    margin-right: 12px;
  }
  animation: fade-in-column-compare 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyleProps) => index ? index * 0.1 : 0 }s both;
  @keyframes fade-in-column-compare {
    0% {
      transform: translateY(50px);
      opacity: 0;
    }
    100% {
      transform: translateY(0);
      opacity: 1;
    }
`

export const ProductImageMin = styled.img`
  max-width: 54px;
  width: 100%;
  border-radius: 3px;
  ${({ secondary }: StyleProps) => secondary ? `
    max-width: 50px;
    height: 44px;
    object-fit: cover;
    background: radial-gradient(at 50% 70%, #c0c0c0, #8e8d91, #6a6a6e);
  ` : ''}
`

export const ProductNameMin = styled.div`
  color: #ffffff;
  font-size: 10px;
  line-height: ${({ secondary }: StyleProps) => secondary ? '1.6' : '19px'};
  overflow: hidden;
  text-overflow: ellipsis;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding-top: 5px;
  @media (max-width: 768px) {
    line-height: unset;
  }
`

export const ProductItemSkeletonMin = styled.div`
  width: 70px;
  height: 64px;
  border: 1px dashed #606060;
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #888888;
  margin-right: 32px;
  @media (max-width: 698px) {
    margin-right: 12px;
  }
  animation: fade-in-column-compare 0.25s cubic-bezier(0.390, 0.575, 0.565, 1.000) 
    ${({ index }: StyleProps) => index ? index * 0.1 : 0 }s both;
  @keyframes fade-in-column-compare {
    0% {
      transform: translateX(-10px);
      opacity: 0;
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
`

export const CompareActionsMin = styled.div`
  position: absolute;
  left: calc(100% + 50px);
  display: flex;
  flex-flow: row-reverse;
  top: 14px;
  @media (max-width: 1134px) {
    left: calc(100% + 10px);
  }
  @media (max-width: 940px) {
    left: unset;
    right: calc(100% + 50px);
  }
  @media (max-width: 768px) {
    right: calc(100% + 35px);
    flex-flow: column-reverse;
    top: -4px;
  }
  @media (max-width: 698px) {
    left: 16px;
    flex-flow: column-reverse;
    top: -30px;
  }
`

export const StyledButtonMin = styled(Button)`
  font-size: 12px;
  height: 34px;
  width: 100%;
  border-radius: 5px;
  margin-right: 20px;
  background-color: #3faad373;
  color: ${WHITE};
  border-color: #3faad3b3;
  &:hover {
		background-color: ${WHITE};
    color: #3faad3;
    border-color: #3faad3;
  }
  &:disabled {
    background-color: lightgray;
  }
  @media (max-width: 768px) {
    margin: 4px 10px;
    font-size: 10px;
    height: 30px;
  }
  @media (max-width: 698px) {
    background: #333333eb;
    width: fit-content;
    height: fit-content;
    padding: 2px 12px;
    border-radius: 3px;
    color: #aadff4;
    font-size: 10px;
    border: none;
  }
`

export const StyledClearAllButtonMin = styled(Button)`
  font-size: 12px;
  height: 34px;
  width: 100%;
  border-radius: 5px;
  background-color: unset;
  color: ${WHITE};
  border-color: #3faad3a8;
  &:hover {
    background-color: unset;
    color: ${BLUE_LIGHT};
    border-color: ${BLUE_LIGHT};
  }
  @media (max-width: 768px) {
    margin: 4px 10px;
    font-size: 10px;
    height: 30px;
  }
  @media (max-width: 698px) {
    display: none;
  }
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MainLayout/CompareIsland/styledComponents.tsx